import React from 'react'

export const BreadcrumbEllipse = props => {
  return (
    <svg viewBox='0 0 8 8' fill='none' {...props}>
      <circle cx={4} cy={4} r={4} fill='#0C509F' />
    </svg>
  )
}
